import React from "react";
import RichText from "components/rich-text";
import Form from "../form";

const SimpleFormLayout = ({ data }) => {
	const { title, subtitle, tag } = data;

	return (
		<div id="modProSignup" className="w-full flex justify-center items-center">
			<div className="py-10 max-w-2xl">
				<div className="flex flex-col">
					<div className="flex w-full">
						<div className="pb-4 px-10 flex-col items-center text-black  pt-10 flex">
							<div className="max-w-md">
								{title && <h4>{title}</h4>}
								{subtitle && <h5 className="pt-3">{subtitle}</h5>}
								<Form tag={tag} />
							</div>
						</div>
					</div>
					<div className="w-full py-4 flex justify-center text-center flex-col">
						<RichText data={{ content: data.footerText }} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default SimpleFormLayout;